/**
 * 数组对象累加求和
 * @param Object arr 数据源
 * @param String field 需要累加的字段
 * @param Number num 保留位数
 */
export function amountTotal(arr, field, num) {
  if (arr.length > 0) {
    let total = arr
      .reduce((prev, cur) => prev + Number(cur[field]), 0)
      .toFixed(num || 0)
    return total === 'NaN' ? 0 : total
  } else {
    return 0
  }
}
